import { render, staticRenderFns } from "./RiderInfo.vue?vue&type=template&id=4e66db3e&scoped=true"
import script from "./RiderInfo.vue?vue&type=script&lang=js"
export * from "./RiderInfo.vue?vue&type=script&lang=js"
import style0 from "./RiderInfo.vue?vue&type=style&index=0&id=4e66db3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e66db3e",
  null
  
)

export default component.exports